export const cacheKeys = {
  getGift: 'getGift',
  getGifts: 'getGifts',
  createGift: 'createGift',
  editGift: 'editGift',
  deleteGift: 'deleteGift',
};